import { toast } from "@/components/ui/use-toast";

export const NotificationPermission = () => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            toast({
                title: "Notifications Enabled",
                description: "You'll now receive alerts for new messages and deals.",
                duration: 3000
              });
          // Pre-load sound for mobile
          new Audio("/assets/sounds/notification.mp3").load();
        }else {
            toast({
              title: "Permission Required",
              description: "Please enable notifications for the best experience.",
              variant: "destructive",
              duration: 3000
            });
          }
        } catch (error) {
          toast({
            title: "Error",
            description: "Could not enable notifications.",
            variant: "destructive",
            duration: 3000
          });
        }
      };

  
    return (
      <button 
        onClick={requestPermission} 
        className="bg-blue-500 text-white p-2 rounded"
      >
        🔔 Allow Notifications
      </button>
    );
  };